import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { APP_ROUTES } from '../../app.routes';

export function authGuard() {
  const authService = inject(AuthService);
  const router = inject(Router);

  const loginUrl = router.createUrlTree([APP_ROUTES.login]);

  if (authService.isAuthenticated()) {
    return true;
  } else {
    return loginUrl;
  }
}
